import { ToggleButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import ColorPicker from '../Components/ColorPicker';
import useMark from '../hooks/useMark';

function ColorButton({ format, Icon, tooltip }) {
    const { getMark, setMark, getFallbackValue } = useMark();
    const [anchorEl, setAnchorEl] = useState(null);

    const value = getMark(format) || getFallbackValue(format) || '';

    return (
        <>
            <Tooltip title={tooltip}>
                <ToggleButton
                    value={value}
                    onMouseDown={e => {
                        e.preventDefault();
                        setAnchorEl(e.currentTarget);
                    }}
                >
                    <Icon sx={{ color: value || '#777' }} fontSize="small" />
                </ToggleButton>
            </Tooltip>
            <ColorPicker
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                value={value}
                onChange={color => {
                    setMark(format, color);
                }}
            />
        </>
    );
}

export default ColorButton;
